import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Box } from 'shared/ui/Box'
import { Dropdown, DropdownContent, DropdownItem } from 'shared/ui/Dropdown'
import { Scrollbar } from 'shared/ui/Scrollbar'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import styles from './styles.module.scss'

type IDaysDropdownProps = {
  value: number
  onChange: (value: number) => void
  days: { value: number; label: string }[]
  label: string
  className?: string
}

export const DaysDropdown = observer(
  ({ value, onChange, days, label, className }: IDaysDropdownProps) => (
    <div className={classnames(styles.followUpWindowWrapper, className)}>
      <span className={styles.followUpWindowLabel}>{label}</span>
      <Box display='flex' alignItems='center' paddingRight='20px' gap='6px'>
        <Dropdown
          width={59}
          placement='bottom'
          triggerComponent={() => (
            <TextFieldPlaceholder
              className={styles.followUpValue}
              size='small'
              variant='outline'
              placeholder={value}
              rightActions={[makeTextFieldIcon({ icon: 'chevronDown', fontSize: 12 })]}
            />
          )}
          customComponent={(close) => (
            <DropdownContent>
              <Scrollbar autoHeight autoHeightMax='160px'>
                <div className={styles.dropdownList}>
                  {days.map((item, index) => (
                    <DropdownItem
                      key={item.value}
                      item={{
                        id: index,
                        label: item.label,
                        onClick: () => {
                          close()
                          onChange(item.value)
                        },
                      }}
                    />
                  ))}
                </div>
              </Scrollbar>
            </DropdownContent>
          )}
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: () => [0, -40],
                },
              },
            ],
          }}
        />
        <span className={styles.daysLabel}>{value === 1 ? 'Day' : 'Days'}</span>
      </Box>
    </div>
  )
)
